import * as Yup from "yup";

export const BankAccountAddFormValidation = Yup.object({
  bank: Yup.string().required("بانک را انتخاب نمایید"),
});
